/**
 * Puts the  application together
 * 
 */

import { h } from 'preact'; /** @jsx h */
import { ErrorBoundary, LocationProvider, Router, Route } from 'preact-iso';

import { Module } from '@pyqml/model';
import { ROUTES } from "@pyqml/shared";

import { Article } from "../pages/Article";
import { Home } from "../pages/Home";
import { CoursePage } from "../pages/Course";
import { Subscribe } from '../pages/Subscribe';
import { Login } from '../pages/Login';
import { AppPage } from "../components/AppPage";
import { Category } from '../pages/Category';
import { Privacy } from '../pages/Privacy';
import { About } from '../pages/About';
import { Settings } from '../pages/Settings';
import { Posts } from '../pages/Posts';
import { Algorithms } from '../pages/Algorithms';
import { WikiPage } from '../pages/Wiki';
import { Questionnaire } from '../pages/Questionnaire';
import { Unsubscribe } from '../pages/Unsubscribe';
import { Courses } from '../pages/Courses';


import { Environment, type IEnvironmentProps } from './Environment';
import { CacheableQueryProvider } from './CacheableQueryProvider';
//import { PublishedAbstractsProvider } from '../provider/PublishedAbstractsProvider';
import { AuthProvider } from './AuthProvider';
import { Bookshelf } from '../pages/Bookshelf';
import { ProtectedRoute } from './ProtectedRoute';
import { Projects } from '../pages/Projects';
import { Passage } from '../pages/Passage';
import { Comics } from '../pages/Comics';



const pyqml_AUTH_KEY = "pyqmlauth";


export type IClientProps = IEnvironmentProps & { test?: string };

export const Client = (props: IClientProps) => (
    <Environment {...props} >
        <LocationProvider>
            <AuthProvider
                authKey={pyqml_AUTH_KEY}
                loginRoute={ROUTES.BLOG_LOGIN}
                loginEndpoint={ROUTES.CLOUDAPI_AUTH_LOGIN}
                signupEndpoint={ROUTES.CLOUDAPI_AUTH_REQUESTLOGIN}
                signinDestination={ROUTES.BLOG_HOME}
            >
                <ErrorBoundary>
                    <CacheableQueryProvider>
                        
                        {/** 
                         * MAKE SURE TO LOAD ALL THE DATA REQUIRED FOR A CERTAIN PAGE ON EXACTLY THAT PAGE
                         * NOT in a parent provider, NOT in a child provider
                         */}

                        <Router>
                            <Route path={`/${ROUTES.BLOG_DRAFT}/${ROUTES.BLOG_WIKI}/:${ROUTES.PARAM_SLUG}/:${ROUTES.PARAM_PASSAGESLUG}`} component={(p) => <AppPage><Passage {...p} draft={true}/></AppPage>} />
                            <Route path={`/${ROUTES.BLOG_DRAFT}/${ROUTES.BLOG_WIKI}/:${ROUTES.PARAM_SLUG}?`} component={(p) => <AppPage><WikiPage {...p} draft={true}/></AppPage>} />
                            <Route path={`/${ROUTES.BLOG_DRAFT}/${ROUTES.BLOG_COURSES}/:${ROUTES.PARAM_SLUG}?`} component={(p) => <AppPage><CoursePage {...p} group={"pyqml"} draft={true}/></AppPage>} />
                            <Route path={`/${ROUTES.BLOG_DRAFT}/${ROUTES.BLOG_PROJECTS}/:${ROUTES.PARAM_SLUG}`} component={(p) => <AppPage><CoursePage {...p} group={Module.MODULE_GROUP.PROJECT} draft={true}/></AppPage>} />
                            <Route path={`/${ROUTES.BLOG_DRAFT}/${ROUTES.BLOG_ALGORITHMS}/:${ROUTES.PARAM_SLUG}`} component={(p) => <AppPage><CoursePage {...p} group={Module.MODULE_GROUP.ALGORITHM} draft={true}/></AppPage>} />
                            <Route path={`/${ROUTES.BLOG_DRAFT}/:${ROUTES.PARAM_SLUG}`} component={(p) => <AppPage><Article {...p} draft={true}/></AppPage>} />
                            
                            <Route path={`/${ROUTES.BLOG_WIKI}/:${ROUTES.PARAM_SLUG}/:${ROUTES.PARAM_PASSAGESLUG}`} component={(p) => <AppPage><Passage {...p} draft={true}/></AppPage>} />
                            <Route path={`/${ROUTES.BLOG_WIKI}/:${ROUTES.PARAM_SLUG}?`} component={(p) => <AppPage><WikiPage {...p}/></AppPage>} />
                            <Route path={`/${ROUTES.BLOG_CATEGORY}/:${ROUTES.PARAM_SLUG}`} component={(p) => <AppPage><Category {...p}/></AppPage>} />
                            <Route path={`/${ROUTES.BLOG_COURSE}/:${ROUTES.PARAM_SLUG}`} component={(p) => <AppPage><CoursePage {...p} group={"pyqml"}/></AppPage>} />
                            <Route path={`/${ROUTES.BLOG_TEASERCOURSE}/:${ROUTES.PARAM_SLUG}`} component={(p) => <AppPage><CoursePage {...p} group={Module.MODULE_GROUP.TEASER}/></AppPage>} />
                            <Route path={`/${ROUTES.BLOG_ALGORITHMCOURSE}/:${ROUTES.PARAM_SLUG}`} component={(p) => <AppPage><CoursePage {...p} group={Module.MODULE_GROUP.ALGORITHM}/></AppPage>} />
                            <Route path={`/${ROUTES.BLOG_PROJECTCOURSE}/:${ROUTES.PARAM_SLUG}`} component={(p) => <AppPage><CoursePage {...p} group={Module.MODULE_GROUP.PROJECT}/></AppPage>} />
                            <Route path={`/${ROUTES.BLOG_ALGORITHMS}/:${ROUTES.PARAM_SLUG}`} component={(p) => <AppPage><CoursePage {...p} group={Module.MODULE_GROUP.ALGORITHM} draft={true}/></AppPage>} />
                            <Route path={`/${ROUTES.BLOG_PROJECTS}/:${ROUTES.PARAM_SLUG}`} component={(p) => <AppPage><CoursePage {...p} group={Module.MODULE_GROUP.PROJECT} draft={true}/></AppPage>} />
                            

                            <Route default path={ROUTES.BLOG_HOME} component={(p) => <AppPage><Home {...p}/></AppPage>} />
                            <Route path={`/${ROUTES.BLOG_LOGIN}`} component={(p) => <AppPage><Login {...p}/></AppPage>} />
                            <Route path={`/${ROUTES.BLOG_UNSUBSCRIBE}`} component={(p) => <AppPage><Unsubscribe {...p}/></AppPage>} />
                            <Route path={`/${ROUTES.BLOG_SUBSCRIBE}`} component={(p) => <AppPage><Subscribe {...p}/></AppPage>} />

                            <Route path={`/${ROUTES.BLOG_PRIVACY}`} component={(p) => <AppPage><Privacy {...p}/></AppPage>} />
                            <Route path={`/${ROUTES.BLOG_ABOUT}`} component={(p) => <AppPage><About {...p}/></AppPage>} />
                            
                            <Route path={`/${ROUTES.BLOG_ALGORITHMS}`} component={(p) => <AppPage><Algorithms {...p}/></AppPage>} />
                            <Route path={`/${ROUTES.BLOG_COURSES}`} component={(p) => <AppPage><Courses {...p}/></AppPage>} />
                            <Route path={`/${ROUTES.BLOG_POSTS}`} component={(p) => <AppPage><Posts {...p}/></AppPage>} />
                            <Route path={`/${ROUTES.BLOG_PROJECTS}`} component={(p) => <AppPage><Projects {...p}/></AppPage>} />
                            <Route path={`/${ROUTES.BLOG_BOOKS}`} component={(p) => <AppPage><Bookshelf {...p}/></AppPage>} />
                            <Route path={`/${ROUTES.BLOG_COMICS}`} component={(p) => <AppPage><Comics {...p}/></AppPage>} />
                            

                            <Route path={`/${ROUTES.BLOG_SETTINGS}`} component={(p) => <ProtectedRoute loginRoute={ROUTES.BLOG_LOGIN}><AppPage><Settings {...p}/></AppPage></ProtectedRoute>} />
                            <Route path={`/${ROUTES.BLOG_TAMQUESTIONNAIRE}`} component={(p) => <AppPage><Questionnaire {...p}/></AppPage>} />
                            
                            
                            <Route path={`:${ROUTES.PARAM_SLUG}`} component={(p) => <AppPage><Article {...p}/></AppPage>} />
                            
                        </Router>
                    
                    </CacheableQueryProvider>
                </ErrorBoundary>
            </AuthProvider>
        </LocationProvider>
    </Environment>
)

